export const APPROVAL_ACTION = {
    SEND_TO_INTERNAL_REVIEW: 'send-to-internal-review',
    RETURN_TO_DRAFT: 'return-to-draft',
    PUBLISH: 'publish',
    APPROVE: 'approve',
    REQUEST_CHANGES: 'request-changes',
    REJECT: 'reject',
    WITHDRAW: 'withdraw',
    EDIT: 'edit',
};
export const APPROVAL_LIST_VIEW = {
    INBOX: 'inbox',
    MINE: 'mine',
    WAITING_CLIENT: 'waiting-client',
    DECIDED: 'decided',
    ALL: 'all',
};
//# sourceMappingURL=approvals.js.map